<template>
  <section>
    <div class="lm-header">
      <h2
        class="title is-5"
        v-text="$t('DashboardAvailable.title').toUpperCase()"
      />
      <h3
        class="subtitle is-5"
        v-text="$t('Common.filters')"
      />
    </div>
    <filters
      v-bind="flag"
    />
    <partner-orders
      v-bind="flag"
    />
  </section>
</template>

<script>
import Filters from '@/components/filters/Filters'
import PartnerOrders from '@/components/dashboard/PartnerOrders'

export default {
  name: 'DashboardOrders',
  beforeCreate () {
    this.$store.dispatch('filters/flush')
  },
  beforeDestroy () {
    this.$eventBus.$off('orders')
    this.$eventBus.$off('emptyOrders')
    this.$eventBus.$off('getAvailableOrders')
    this.$eventBus.$off('getOrders')
    this.$eventBus.$off('onPageChange')
    this.$eventBus.$off('cleanFilters')
  },
  components: {
    Filters,
    PartnerOrders
  },
  data () {
    return {
      flag: { type: 'available' }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardAvailable.vue